import Footer from '@/components/footer';
import PageLoader from '@/components/loader';
import useAuth from '@/hooks/use-auth';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const PublicRoute = () => {
    const { data, isLoading } = useAuth();
    const user = data?.data?.user;
    const location = useLocation();

    if (isLoading) {
        return <PageLoader />;
    }

    if (
        location.pathname.includes('/verify-email-change') ||
        location.pathname.includes('/verify-email')
    ) {
        const userId = user?.id;
        return <Outlet context={{ userId }} />;
    }

    return !user ? (
        <>
            <Outlet />
            <Footer />
        </>
    ) : (
        <Navigate
            to='/mfa'
            replace
        />
    );
};

export default PublicRoute;
